var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-item',{attrs:{"route":"Access","id":_vm.item.id,"id-name":"access"}},[_c('app-item-title',{attrs:{"text":_vm.item.user.name,"subtitle":_vm.levels[_vm.item.level]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }